/**
 * Cart Milestone Celebration Animation
 * Triggers confetti + toast messages for:
 * - Free shipping (€50)
 * - First free gift (€70)
 * - Second free gift (€120)
 */
(function () {
  'use strict';

  /* ── Config (can be overridden from FloatingCartPill data attrs) ── */
  var DEFAULT_THRESHOLDS = {
    shipping: 5000,
    gift1: 7000,
    gift2: 12000
  };

  var CONFETTI_DURATION = 2500; // ms
  var MESSAGE_DURATION = 4000; // ms
  var PARTICLE_COUNT = 80;

  var MILESTONES = [
    {
      id: 'shipping',
      thresholdCents: DEFAULT_THRESHOLDS.shipping,
      message: 'FREE SHIPPING!',
      sessionKey: 'cleenlab_free_shipping_celebrated'
    },
    {
      id: 'gift1',
      thresholdCents: DEFAULT_THRESHOLDS.gift1,
      message: 'Free Gift Available!',
      sessionKey: 'cleenlab_free_gift_1_celebrated'
    },
    {
      id: 'gift2',
      thresholdCents: DEFAULT_THRESHOLDS.gift2,
      message: 'Second Free Gift Available!',
      sessionKey: 'cleenlab_free_gift_2_celebrated'
    }
  ];

  /* Cleenlab-inspired palette */
  var COLORS = [
    '#e8c4c4', // soft rose
    '#f2d7b6', // warm beige
    '#d4af37', // classic gold
    '#c9b037', // muted gold
    '#a3b899', // sage green
    '#b8d4b8', // soft mint
    '#f5e6e0', // blush
    '#ffffff' // white sparkle
  ];

  /* ── State ──────────────────────────────────────────────── */
  var previousTotal = 0;
  var celebrated = {
    shipping: false,
    gift1: false,
    gift2: false
  };

  /* ── Storage helpers ─────────────────────────────────────── */
  function getSessionFlag(key) {
    try {
      var value = sessionStorage.getItem(key);
      return value === '1' || value === 'true';
    } catch (e) {
      return false;
    }
  }

  function setSessionFlag(key, value) {
    try {
      if (value) {
        sessionStorage.setItem(key, '1');
      } else {
        sessionStorage.removeItem(key);
      }
    } catch (e) {
      /* no-op */
    }
  }

  function parseThreshold(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function syncCelebratedFromSession() {
    MILESTONES.forEach(function (milestone) {
      celebrated[milestone.id] = getSessionFlag(milestone.sessionKey);
    });
  }

  function setCelebrated(milestoneId, value) {
    var milestone = MILESTONES.find(function (entry) {
      return entry.id === milestoneId;
    });
    if (!milestone) return;

    celebrated[milestone.id] = Boolean(value);
    setSessionFlag(milestone.sessionKey, Boolean(value));
  }

  function resetCelebrations() {
    MILESTONES.forEach(function (milestone) {
      celebrated[milestone.id] = false;
      setSessionFlag(milestone.sessionKey, false);
    });
  }

  /* ── Helpers ────────────────────────────────────────────── */
  function rand(min, max) {
    return Math.random() * (max - min) + min;
  }

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  /* ── Confetti canvas ────────────────────────────────────── */
  function spawnConfetti(originEl) {
    var rect = originEl.getBoundingClientRect();
    var cx = rect.left + rect.width / 2;
    var cy = rect.top + rect.height / 2;

    var canvas = document.createElement('canvas');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    canvas.style.cssText =
      'position:fixed;top:0;left:0;width:100vw;height:100vh;pointer-events:none;z-index:1000000;';
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var particles = [];
    var startTime = performance.now();

    for (var i = 0; i < PARTICLE_COUNT; i++) {
      var angle = rand(0, Math.PI * 2);
      var speed = rand(4, 12);
      particles.push({
        x: cx,
        y: cy,
        vx: Math.cos(angle) * speed * rand(0.6, 1.4),
        vy: Math.sin(angle) * speed * rand(0.6, 1.4) - rand(2, 6),
        w: rand(4, 8),
        h: rand(6, 12),
        color: pick(COLORS),
        rotation: rand(0, 360),
        rotSpeed: rand(-8, 8),
        gravity: rand(0.12, 0.22),
        opacity: 1
      });
    }

    function frame(now) {
      var elapsed = now - startTime;
      if (elapsed > CONFETTI_DURATION) {
        canvas.remove();
        return;
      }

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      var fadeStart = CONFETTI_DURATION * 0.6;
      var globalAlpha =
        elapsed > fadeStart ? 1 - (elapsed - fadeStart) / (CONFETTI_DURATION - fadeStart) : 1;

      for (var j = 0; j < particles.length; j++) {
        var p = particles[j];
        p.vy += p.gravity;
        p.x += p.vx;
        p.y += p.vy;
        p.vx *= 0.99;
        p.rotation += p.rotSpeed;
        p.opacity = globalAlpha;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rotation * Math.PI) / 180);
        ctx.globalAlpha = p.opacity;
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }

      requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  /* ── Milestone toast ─────────────────────────────────────── */
  function showMessage(originEl, messageText) {
    var rect = originEl.getBoundingClientRect();

    var msg = document.createElement('div');
    msg.className = 'cl-free-shipping-toast';
    msg.innerHTML =
      '<span class="cl-free-shipping-toast__emoji">🎉</span>' +
      '<span class="cl-free-shipping-toast__text">' +
      messageText +
      '</span>';

    /* Position below the floating cart pill */
    msg.style.position = 'fixed';
    msg.style.top = rect.bottom + 12 + 'px';
    msg.style.right = window.innerWidth - rect.right + 'px';
    msg.style.zIndex = '1000001';

    document.body.appendChild(msg);

    /* Trigger entrance animation */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        msg.classList.add('is-visible');
      });
    });

    /* Remove after MESSAGE_DURATION */
    setTimeout(function () {
      msg.classList.remove('is-visible');
      msg.classList.add('is-leaving');
      setTimeout(function () {
        msg.remove();
      }, 500);
    }, MESSAGE_DURATION);
  }

  function celebrateMilestone(milestone) {
    setCelebrated(milestone.id, true);

    var pill = document.getElementById('FloatingCartPill');
    if (!pill) return;

    /* Small delay so the cart pill has updated first */
    setTimeout(function () {
      spawnConfetti(pill);
      showMessage(pill, milestone.message);
    }, 300);
  }

  function maybeCelebrate(totalCents) {
    MILESTONES.forEach(function (milestone) {
      if (celebrated[milestone.id]) return;

      var crossedThreshold = previousTotal < milestone.thresholdCents && totalCents >= milestone.thresholdCents;
      if (crossedThreshold) {
        celebrateMilestone(milestone);
      }
    });

    previousTotal = totalCents;
  }

  function markMilestonesAsCelebratedWithoutAnimation(totalCents) {
    MILESTONES.forEach(function (milestone) {
      if (totalCents >= milestone.thresholdCents && !celebrated[milestone.id]) {
        setCelebrated(milestone.id, true);
      }
    });
  }

  function extractCartData(payload) {
    if (!payload || typeof payload !== 'object') return null;

    if (typeof payload.item_count !== 'undefined') return payload;
    if (payload.cartData && typeof payload.cartData.item_count !== 'undefined') return payload.cartData;

    return null;
  }

  /* ── Bootstrap ──────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    var pill = document.getElementById('FloatingCartPill');
    if (!pill) return;

    /* Threshold overrides from data attrs (if present) */
    var freeShippingThreshold = parseThreshold(
      pill.dataset.freeShippingThreshold,
      DEFAULT_THRESHOLDS.shipping
    );
    var freeGiftThresholdOne = parseThreshold(
      pill.dataset.freeGiftThresholdOne,
      DEFAULT_THRESHOLDS.gift1
    );
    var freeGiftThresholdTwo = parseThreshold(
      pill.dataset.freeGiftThresholdTwo,
      DEFAULT_THRESHOLDS.gift2
    );

    MILESTONES[0].thresholdCents = freeShippingThreshold;
    MILESTONES[1].thresholdCents = freeGiftThresholdOne;
    MILESTONES[2].thresholdCents = freeGiftThresholdTwo;

    syncCelebratedFromSession();

    var initialTotal = parseInt(pill.dataset.initialTotal || '0', 10);
    var initialCount = parseInt(pill.dataset.initialCount || '0', 10);
    previousTotal = Number.isFinite(initialTotal) ? initialTotal : 0;

    if (!Number.isFinite(initialCount) || initialCount <= 0) {
      /* Reset milestone state when cart starts empty */
      resetCelebrations();
      previousTotal = 0;
    } else {
      /* If page loads already above thresholds, don't auto-fire; mark silently */
      markMilestonesAsCelebratedWithoutAnimation(previousTotal);
    }

    function handleCartData(cartData) {
      var resolvedCart = extractCartData(cartData);
      if (!resolvedCart) return;

      var itemCount = Number(resolvedCart.item_count || 0);
      var totalCents = Number(resolvedCart.total_price || 0);

      if (itemCount === 0) {
        resetCelebrations();
        previousTotal = 0;
        return;
      }

      maybeCelebrate(totalCents);
    }

    function fetchAndCheck() {
      fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          handleCartData(cart);
        })
        .catch(function () {});
    }

    document.addEventListener('cleenlab:cart-added', function (event) {
      if (event && event.detail) {
        handleCartData(event.detail);
      } else {
        fetchAndCheck();
      }
    });

    document.addEventListener('product:added-to-cart', function (event) {
      if (event && event.detail) {
        handleCartData(event.detail);
      } else {
        fetchAndCheck();
      }
    });

    document.addEventListener('cart:updated', function (event) {
      if (event && event.detail) {
        handleCartData(event.detail);
      } else {
        fetchAndCheck();
      }
    });

    document.addEventListener('cart-updated', function (event) {
      if (event && event.detail) {
        handleCartData(event.detail);
      } else {
        fetchAndCheck();
      }
    });

    /* PubSub system used by Shopify Dawn theme */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (data) {
          handleCartData(data);
        } else {
          fetchAndCheck();
        }
      });
    }
  });
})();
